module.exports = __webpack_public_path__ + "media/src/images/icons/plus-dec32c2956587c1f808f3c4e97023c0e.svg";